import { marked } from 'marked';

// ponytail: renders HR/admin-authored markdown as-is via {@html} — no
// sanitizer (no dep for it is installed). Only hr/admin can write policy or
// announcement bodies (RequireHR-gated PUT), so this trusts the same staff
// who already have write access elsewhere in the app, not arbitrary users.
// Upgrade path: add a sanitizer (e.g. dompurify) if policy bodies ever
// accept content from a wider trust boundary.
export function renderMarkdown(src: string): string {
  return marked.parse(src, { async: false }) as string;
}
